import type { DateTime } from 'luxon'
import { parseDatetime } from './datetime'

/** Structural route subset shared by the list fragment and the detail query. */
type ReportAtRoute = {
  startTimeLocal?: string | null
  waypoints?: readonly { scheduledArrivalTime?: string | null }[] | null
}

/** v1: a zero duration means the crew reports at departure. */
export const hasReportAtWindow = (reportAtDurationSeconds: number): boolean =>
  reportAtDurationSeconds > 0

/**
 * Report At (v1): the route start, minus `crew.assignmentReportAtDuration`
 * when the first stop has no scheduled arrival.
 */
export const assignmentReportAt = (
  route: ReportAtRoute | null | undefined,
  reportAtDurationSeconds: number,
): DateTime | undefined => {
  if (!route) return undefined
  const startDt = parseDatetime(route.startTimeLocal)
  if (!startDt) return undefined
  const firstWp = route.waypoints?.[0]
  const appliesReportAtOffset =
    firstWp != null && firstWp.scheduledArrivalTime == null
  if (!appliesReportAtOffset) return startDt
  return startDt.minus({ seconds: reportAtDurationSeconds })
}
